import { Logger } from "@expert/logging";

import { useChatStore } from "@/sdk";
import { useSessionStore } from "@/sdk/sessions/session.store";

import type AmazonConnectChatContact from "../AmazonConnectChatContact";

import { getChatMetadata } from "../api/getChatMetadata";

export async function handleContactEnded(contact: connect.Contact, logger: Logger): Promise<void> {
    const contactId = contact.getContactId();
    const contactLogger = logger.child({ contactId, action: "handleContactEnded" });

    try {
        contactLogger.debug("Processing contact ended event");

        // Check if close reason is already set (from websocket push)
        const existingCloseReason = useChatStore.getState().getCloseReason(contactId);
        if (existingCloseReason) {
            contactLogger.debug(
                { closeReason: existingCloseReason },
                "Close reason already set, skipping metadata fetch",
            );
            return;
        }

        const task = useSessionStore.getState().getTask(contactId) as AmazonConnectChatContact | undefined;
        const partner = task?.partner ?? contact.getAttributes()?.partner?.value;

        if (!partner) {
            contactLogger.warn("Cannot fetch chat metadata: partner not available from task or contact attributes");
            return;
        }

        // Fetch chat metadata to get close reason
        const chatMetadata = await getChatMetadata(partner, contactId);
        if (chatMetadata.length === 0) {
            contactLogger.warn("No chat metadata returned from API");
            return;
        }

        const metadata = chatMetadata[0];
        if (metadata.closeReason) {
            useChatStore.getState().updateCloseReason(contactId, metadata.closeReason);
            contactLogger.debug({ closeReason: metadata.closeReason }, "Close reason saved to chat store");
        }
    } catch (error) {
        contactLogger.warn({ error }, "Failed to process contact ended event");
    }
}
